import { Controller } from "@hotwired/stimulus";

// Gère l'état indeterminate des checkboxes "select all"
// L'état indeterminate est une propriété JS, pas un attribut HTML
export default class extends Controller {
  connect() {
    this.updateIndeterminate();
  }

  updateIndeterminate() {
    const indeterminate = this.element.dataset.indeterminate === "true";
    this.element.indeterminate = indeterminate;
  }
}
